<template>
    <v-dialog @input="close" v-if="rechargeInfo !== null" v-model="opened" max-width="400px">      
        <v-card class="confirm-recharge">
            <div style="padding: 10px 20px 0 20px; text-align: right;">
                <span @click="()=>{ close() }" class="close">X</span>
            </div>
            <v-card-text v-if="!rechargeInfo.Type || rechargeInfo.Type =='recharge'">
                <strong>{{ t('CONFIRMAR_RECARGA') }}</strong>
                <label for="">{{ t('VALOR_TOTAL') }}</label>
                <strong class="value">R$ {{ formatMoney(rechargeInfo.Value.replace(',','.')) }}</strong>
                <label for="">{{ t('FORMA_DE_PAGAMENTO') }}</label>
                <strong class="value">{{ rechargeInfo.CreditCard }}</strong>
                <div v-if="rechargeInfo.Promotion">
                    <div v-if="rechargeInfo.AceitePromocao">
                        <label>{{ rechargeInfo.Promotion.acceptMessage }}</label>
                        <strong style="color: #ED1164; font-size: 24px; font-weight: bold; text-align:center">{{ pontos }}</strong>
                    </div>
                    <div v-else>
                        <label>{{ rechargeInfo.Promotion.rejectMessage }}</label>
                    </div>
                </div>
                <a @click="submit()" style="width: 100%; margin-top: 15px"  appEvent="true" appEventCategory="recarga" appEventLabel="confirmar" class="btn block">{{ t('CONFIRMAR') }}</a>
                <strong v-if="rechargeInfo.CreditCard == 'PIX'">{{ t('LIMITE_TEMPO_PIX') }}</strong>
            </v-card-text>

            <v-card-text v-if="rechargeInfo.Type == 'qrcode'">
                <strong>{{ t('CONFIRMAR_COMPRA_BILHETES') }}</strong>
                <label for="">{{ t('VALOR_TOTAL') }}</label>
                <strong class="value">R$ {{ formatMoney(rechargeInfo.Value.replace(',','.')) }}</strong>
                <label for="">{{ t('NR_PASSAGENS') }}</label>
                <strong class="value">{{ rechargeInfo.QtdPassagens }}</strong>
                <label for="">{{ t('FORMA_DE_PAGAMENTO') }}</label>
                <strong class="value">{{ rechargeInfo.CreditCard }}</strong>
                <a @click="submit()" style="width: 100%; margin-top: 15px"  appEvent="true" appEventCategory="recarga" appEventLabel="confirmar" class="btn block">{{ t('CONFIRMAR') }}</a>
                <strong v-if="rechargeInfo.CreditCard == 'PIX'">{{ t('LIMITE_TEMPO_PIX') }}</strong>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {/*VTextField,VBtn,*/VDialog,VCard,/*VCardTitle,*/VCardText/*,VApp*/} from 'vuetify/lib'
import { formatMoney } from '../helpers/helpers'
import { translate } from '../services/translate.service';
export default {
  name: 'ConfirmRechargeModal',
  props: {
      rechargeInfo:{
        type: Object,
        default: null
      },
  },
  methods: {
    t:translate,
      formatMoney(v) { return formatMoney(v*100)},
      close() {
        this.$emit('close-recharge');
      },
      submit() {
        this.$emit('submit-recharge');
      }
  },
  data() {
      return {
          opened: true
      }
  },
  computed: {
      pontos() {
          if(!this.rechargeInfo.Promotion || !this.rechargeInfo.AceitePromocao) return 0;
          let multiplicador = this.rechargeInfo.Promotion.multiplier || 0;
          let value = Math.floor(this.rechargeInfo.Value.split(',')[0]);
          return multiplicador * value;
      }
  },
  components: {
      VDialog,
      //VApp,
      VCard,
      //VCardTitle,
      VCardText
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
    strong, label {
        display: block;
        text-align: center;
    }
    strong {
        font-weight: bold;
        &.value {
            color: #E46C0A;
        }
    }
</style>
